var React = require('react');

function ShareFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.68926 17.433C1.14043 17.433 0.695801 17.0022 0.695801 16.4708V0.962163C0.695801 0.430687 1.1405 0 1.68926 0H17.7024C18.251 0 18.6958 0.430687 18.6958 0.962163V16.4708C18.6958 17.0022 18.251 17.433 17.7024 17.433H13.1155V10.682H15.4552L15.8056 8.05101H13.1155V6.37128C13.1155 5.60955 13.3339 5.09045 14.4618 5.09045L15.9003 5.08984V2.73666C15.6515 2.70459 14.7976 2.63296 13.8041 2.63296C11.7301 2.63296 10.3102 3.85907 10.3102 6.11072V8.05101H7.96447V10.682H10.3102V17.433H1.68926Z","fill":"#FFB699"}));
}

ShareFacebook.defaultProps = {"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none"};

module.exports = ShareFacebook;

ShareFacebook.default = ShareFacebook;
